import React, { useEffect } from 'react';
import {
  Button,
  ButtonGroup,
  CssBaseline,
  Box,
  Typography,
  Container,
  Paper,
  Link,
  Grid,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import StripeCheckout from 'react-stripe-checkout';
import API from '@aws-amplify/api';
import Auth from '@aws-amplify/auth';
import { withRouter } from 'react-router-dom';
import './Billing.css';
import { Image } from 'react-bootstrap';

import MaverickSpinner from '../components/Spinner';
import config from '../config';

/** Stripe publishable key */
const STRIPE_PUBLISHABLE_KEY = config.STRIPE_PUBLIC_KEY;

const { STRIPE_V2 } = config;
function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://maverickapp.io/">
        maverickapp.io
      </Link>
      {` ${new Date().getFullYear()}.`}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
  },
  root: {
    display: 'flex',
  },
  heroContent: {
    paddingTop: '20px',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  title: {
    flexGrow: 1,
  },

  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    // height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    fontFamily: 'Hind',
  },

  contained: {
    backgroundColor: '#27A9E0',
    color: '#FFF',
    marginLeft: 'auto !important',
    marginRight: 'auto !important',
    display: 'block !important',
    border: '1px solid transparent',
    '&:hover': {
      color: '#27A9E0',
      backgroundColor: '#FFF',
      border: '1px solid',
    },
  },
  button: {
    backgroundColor: '#27A9E0',
    color: '#FFF',

    '&:hover': { color: '#27A9E0', backgroundColor: '#FFF' },
  },

  outlined: {
    marginLeft: 'auto !important',
    marginRight: 'auto !important',
    display: 'block !important',
    border: '1px solid',
    color: '#27A9E0',
  },

  activeStep: {
    color: '#27A9E0 !important',
  },
  icon: {
    color: 'red !important',
  },
  fixedHeight: {
    height: 240,
  },
}));

function Billing({ location }) {
  const classes = useStyles();
  const [isAuthenticated, userHasAuthenticated] = React.useState(false);

  const [userEmail, setUserEmail] = React.useState();
  const [licenseType] = React.useState('personal');
  const [isLoading, setIsLoading] = React.useState(true);
  const [activeStep] = React.useState(0);
  const [billingTerms, setBillingTerms] = React.useState('Yearly');

  const [subscriptionData, setSubscriptionData] = React.useState({});

  /**
   * Make request to AWS lambda function that handles creating
   * a customer and a subscription plan on stripe
   * @param token - token with stripe key and details entered in stripe form
   * @param productPlan - id of the product plan the user is subscribing to
   */
  const subscribeToProductPlan = async (token, productPlan) => {
    setIsLoading(true);
    const bodyParams = {
      stripeToken: token.id,
      email: token.email,
      licenseRecipient: {
        email: userEmail,
        type: licenseType,
      },
      productPlan,
    };

    const myInit = {
      body: bodyParams,
    };

    try {
      await API.post('mav-outlook-api', '/users/billing', myInit);
      setIsLoading(false);
      window.location.reload(false);
      window.location.href = 'https://maverickapp.io/download/';
    } catch (e) {
      window.location.href = 'https://maverickapp.io/download/';

      console.error(e);
    }
  };

  // eslint-disable-next-line consistent-return
  function getStepContent(step) {
    return (
      <div style={{ display: 'contents' }}>
        <div style={{ textAlign: 'center', height: '6em' }}>
          <ButtonGroup variant="text" color="primary" aria-label="text primary button group">
            <Button
              className="billing-btn"
              style={{ color: '#27a9e0' }}
              variant={billingTerms === 'Monthly' ? 'outlined' : ''}
              onClick={() => {
                setBillingTerms('Monthly');
              }}
            >
              Monthly
            </Button>
            {/* <Button
                  style={{ color: '#27a9e0' }}
                  variant={billingTerms === '6 Month' ? 'outlined' : ''}
                  onClick={() => {
                    // console.log('6month')
                    setBillingTerms('6 Month')
                  }}
                >
                  6 Month
                </Button> */}
            <Button
              className="billing-btn"
              style={{ color: '#27a9e0' }}
              variant={billingTerms === 'Yearly' ? 'outlined' : ''}
              onClick={() => {
                setBillingTerms('Yearly');
              }}
            >
              Yearly
            </Button>
          </ButtonGroup>
        </div>
        <div className="row" />
        <div className="snip1214 row" style={{ display: 'contents' }}>
          {STRIPE_V2[billingTerms].map((column) => (
            <div className={`plan${column.primaryHeader === 'AutoPilot' ? ' featured' : ''}`}>
              <h3 className="plan-title" style={{height: '2.5em', width:'100%'}}>{column.primaryHeader}</h3>
              <div className="plan-cost">
                <span className="plan-price">${column.price}</span>
                <span className="plan-type">/ Month</span>
                <p>{column.stripeDescription}</p>
              </div>
              <ul className="plan-features">
                  <li>
                    <i className="ion-checkmark"> </i>
                    RECON
                  </li>
                  <li>
                    <i className="ion-checkmark"> </i>
                    Auto Prospect Research
                  </li>
                <li>
                  <i className="ion-checkmark"> </i>
                  Up to <b>400</b> Prospects Monthly
                </li>
                <li>
                  <i className="ion-checkmark"> </i>
                  {`Template ${column.primaryHeader !== 'MaverickApp Pro' ? 'Assist' : 'Writing'}`}
                </li>
                <li>
                  <i className="ion-checkmark"> </i>
                  Email Engagement Machine
                </li>
                <li>
                  <i className="ion-checkmark"> </i>
                  Expert 'Wingman' Support
                </li>
                <li>
                  <i className="ion-checkmark"> </i>
                  Onboard/Walk Through Session
                </li>
                <li>
                  <i className="ion-checkmark"> </i>
                  Powerful Real-Time Insight Reporting
                </li>
                {column.primaryHeader === 'MaverickApp Pro' ? (
                  <li style={{ opacity: '0.5' }}>
                    <i className="ion-close"> </i>
                    Success Team
                  </li>
                ) : (
                  <li style={{fontWeight: column.primaryHeader === 'AutoPilot' ?'none' :'bold'}}>
                    <i className="ion-checkmark"> </i>
                  {`${column.primaryHeader === 'AutoPilot' ?'Success Team' :'Dedicated Success Rep'}`}
                  </li>
                )}
                {column.primaryHeader === 'MaverickApp Pro' ? (
                  <li style={{ opacity: '0.5' }}>
                    <i className="ion-close"> </i>
                    Pre-Launch Consultation
                  </li>
                ) : (
                  <li>
                    <i className="ion-checkmark"> </i>
                    Pre-Launch Consultation
                  </li>
                )}
                 {column.primaryHeader === 'MaverickApp Pro' ? (
                  <li style={{ opacity: '0.5' }}>
                    <i className="ion-close"> </i>
                    Managed Email Engagement
                  </li>
                ) : (
                  <li style={{fontWeight: column.primaryHeader === 'AutoPilot' ?'none' :'bold'}}>
                    <i className="ion-checkmark"> </i>
                    {`${column.primaryHeader === 'AutoPilot' ?'Managed Email Engagement' :'Managed Plus Email Engagement'}`}
                  </li>
                )}
                {column.primaryHeader !== 'AutoPilot Top Gun' ? (
                  <li style={{ opacity: '0.5' }}>
                    <i className="ion-close"> </i>
                    Monthly Consulting
                  </li>
                ) : (
                  <li>
                    <i className="ion-checkmark"> </i>
                    Monthly Consulting
                  </li>
                )}
                {/*
                <li>
                  <i className="ion-checkmark"> </i>
                  Template Assist
                </li>
                {column.primaryHeader === 'Lite' ? (
                  <li style={{ opacity: '0.5' }}>
                    <i className="ion-close"> </i>
                    Template Writing
                  </li>
                ) : (
                  <li>
                    <i className="ion-checkmark"> </i>
                    <b>Template Writing</b>
                  </li>
                )} */}
              </ul>
              <div className="plan-select">
                <StripeCheckout
                  name="MaverickApp"
                  description={`${column.primaryHeader}`}
                  token={(token) => subscribeToProductPlan(token, column.id)}
                  billingAddress
                  zipCode
                  panelLabel="Subscribe"
                  stripeKey={STRIPE_PUBLISHABLE_KEY}
                  fullWidth
                >
                  {/* <a href="foo.com">Select Plan</a> */}
                  <Button className={classes[column.buttonVariant]}>Select Plan</Button>
                </StripeCheckout>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  useEffect(() => {
    async function onLoad() {
      let user;
      try {
        await Auth.currentSession();
      } catch (e) {
        if (e !== 'No current user') {
          console.error(e);
          // logging.logToBeta(e)
        }
      }
      try {
        user = await Auth.currentSession();
      } catch (e) {
        console.error(e);
        window.location.href = 'https://signup.maverickapp.io';
      }

      setUserEmail(user.idToken.payload.email);
      userHasAuthenticated(true);
      setSubscriptionData({ subscriptionData: null });
      setIsLoading(false);
    }
    onLoad();
  }, [isAuthenticated]);

  function renderLander() {
    return (
      <div className="lander">
        <div>
          <MaverickSpinner />
        </div>
      </div>
    );
  }

  function renderBilling(data) {
    const fullscreen = true;

    return (
      <div className={fullscreen && 'fullscreen'}>
        <div className={classes.root}>
          <main className={classes.content}>
            <Container maxWidth="lg" className={classes.container}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Paper className={classes.paper}>
                    <div>
                      <div style={{ height: '750px' }}>
                        <>
                          <CssBaseline />
                          <div style={{ textAlign: 'center' }}>
                            <Image
                              src="https://app.maverickapp.io/assets/maverick-logo.png"
                              style={{ maxHeight: '50px', marginBottom: '40px' }}
                            />
                          </div>
                          <Container
                            maxWidth="md"
                            component="main"
                            className={classes.heroContent}
                            style={{ textAlign: 'center' }}
                          ></Container>
                          <div></div>
                          <div>
                            <Typography className={classes.instructions}>
                              {getStepContent(activeStep)}
                            </Typography>
                            <div></div>
                          </div>
                        </>
                      </div>
                    </div>
                  </Paper>
                </Grid>
              </Grid>
              <Box pt={4}>
                <Copyright />
              </Box>
            </Container>
          </main>
        </div>
      </div>
    );
  }

  function renderNotes() {
    return !isLoading && renderBilling(subscriptionData);
  }

  return isAuthenticated ? renderNotes() : renderLander();
}

export default withRouter(Billing);
